// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-f08d8c20]{display:none}.search-btn[data-v-f08d8c20]{--button-border-radius:50%}.search-btn-close[data-v-f08d8c20]{--button-background:var(--c-light)}.search-btn-close i[data-v-f08d8c20]:before{color:var(--c-dark)}.search-btn-close[data-v-f08d8c20]:hover{--button-background:var(--c-grey-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
